import { ManagersTable } from "@/components/managers/managers-table";

export function ManagersPage() {
	return (
		<div className="flex flex-1 flex-col gap-4 p-4 lg:p-6">
			<ManagersTable />
		</div>
	);
}
